import instance from "../instance";


export const logbookApi = {
  getTrips: (roleIds, yachtTypeIds, tidal, dateBefore, dateAfter, offset, limit, countries) => {
    return instance.get(`/v1/logbook/trips?verbose_level=2${roleIds ? `&role_id=${roleIds.map(r => `${r}`).join('|')}` : ''}${yachtTypeIds ? `&yacht_type_id=${yachtTypeIds.map(y => `${y}`).join('|')}` : ''}${tidal !== undefined ? `&tidal=${tidal}` : ''}${dateBefore ? `&before_date=${dateBefore}` : ''}${dateAfter ? `&after_date=${dateAfter}` : ''}&offset=${offset ?? '0'}&limit=${limit ?? '10'}${countries ? `&start_country_id=${countries.map(c => `${c}`).join('|')}` : ''}`)
  },
  getTrip: (tripId) => {
    return instance.get(`/v1/logbook/trips/${tripId}?verbose_level=2`)
  },
  addTrip: (body) => {
    return instance.post(`/v1/logbook/trips?verbose_level=2`, body)
  },
  editTrip: (tripId, isShareChanges, body) => {
    return instance.patch(`/v1/logbook/trips/${tripId}?verbose_level=2${isShareChanges ? `&share_changes=${isShareChanges}` : ''}`, body)
  },
  deleteTrip: (tripId) => instance.delete(`/v1/logbook/trips/${tripId}`),
  sendInvitations: (tripId, body) => {
    // console.log(tripId, body)
    return instance.post(`/v1/logbook/trips/${tripId}/invitations`, body)
  },
  getInvitation: (token) => instance.post(`/v1/logbook/trips/accept-invitation?verbose_level=2`, `"${token}"`),
  acceptInvitation: (trip_id, invitation_id, declined, accepted, user_id) => {
    return instance.patch(`/v1/logbook/trips/${trip_id}/invitations/${invitation_id}`, {user_id, trip_id, accepted, declined})
  },
  sendLogbook: (body) => instance.post(`/v1/logbook/send`, body),
  getTripInvitations: (tripId, body) => instance.post(`/v1/logbook/trips/${tripId}/invitations/list`, body),
  getExperience: (profileId) => instance.get(`/v1/profiles/${profileId}/experience`)
}
